import { schema } from 'normalizr'

const tableMenuNavigation = new schema.Entity('tableMenuNavigations')

export default tableMenuNavigation
